import { differenceInCalendarDays, format, formatDistance, formatDistanceStrict } from 'date-fns';

const DATE_TIME_FORMAT = 'd MMM yyyy, HH:mm';

/** "12 Oct 2026, 14:30" in the user's local time zone; empty or invalid input → ''. */
export function formatLocalDateTime(input: string | Date | null | undefined): string {
  if (!input) return '';
  const date = typeof input === 'string' ? new Date(input) : input;
  return Number.isNaN(date.getTime()) ? '' : format(date, DATE_TIME_FORMAT);
}

/**
 * Per DEV-3856: today shows minutes/hours elapsed, the next two calendar days show "N days
 * ago", and anything older shows the full date and time. Day boundaries are calendar-based
 * (midnight-to-midnight), not rolling 24h windows, per the ticket's "current day" wording.
 *
 * Uses `formatDistance`/`formatDistanceStrict` (which take an explicit reference date) rather
 * than the `*ToNow` variants (which silently read `Date.now()`), so `now` is actually honored —
 * both for a deterministic `now` in tests and for a stable render if the tab stays open.
 */
export function formatNotificationTimestamp(input: string | Date, now: Date = new Date()): string {
  const date = typeof input === 'string' ? new Date(input) : input;
  const dayDiff = differenceInCalendarDays(now, date);

  if (dayDiff <= 0) {
    return formatDistance(date, now, { addSuffix: true, includeSeconds: true });
  }
  if (dayDiff <= 2) {
    return formatDistanceStrict(date, now, { addSuffix: true, unit: 'day' });
  }
  return format(date, DATE_TIME_FORMAT);
}
